<template>
  <div
    :class="{ overlay }"
    :style="{ backgroundColor: overlayColor }"
    v-if="open"
    v-show="realOpen"
  >
    <div
      class="popup"
      :class="{ center, centerHorizontal, centerVertical, showBubble }"
      :style="{ width, top, bottom, right, left, maxWidth, minWidth, opacity }"
    >
      <div class="row popupHeader" v-if="title">
        <div class="col">
          <div class="popupHeaderLogo">
            <img
              class="popupInfoIcon"
              :src="infoIcon"
              v-if="showInfoIcon"
              @load="onImgLoad"
            />
            <img
              v-if="showClose"
              :src="crossIcon"
              class="popupClose"
              @click="closePopup"
              @load="onImgLoad"
            />
            <img
              v-if="showMinimize"
              :src="minimizeIcon"
              class="popupMinimize"
              @click="togglePopup"
              @load="onImgLoad"
            />

            <div class="popupHeaderTitle">
              {{ title }}
            </div>
          </div>
        </div>
      </div>

      <div class="middleLine" v-if="title"></div>

      <div
        class="row popupTextSection"
        :style="{ height: `calc(${height} - 115px)` }"
        v-show="!minimized"
      >
        <div
          class="textSection"
          :class="{
            row: bodyType === 'text',
          }"
          :style="{ padding: paddingText }"
        >
          <div
            class="popupText scroll"
            :style="{
              height: buttonR ? 'calc(100% - 45px)' : '100%',
              fontSize: fontSizeBody,
            }"
            v-if="body"
          >
            <span v-if="bodyType === 'text'">{{ body }}</span>
            <div v-else-if="bodyType === 'carousel'">
              <div
                id="carouselBody"
                class="carousel slide carousel-dark"
                style="display: flex"
              >
                <button
                  class="carousel-control-prev"
                  type="button"
                  data-bs-target="#carouselBody"
                  data-bs-slide="prev"
                  style="position: static"
                >
                  <span
                    class="carousel-control-prev-icon"
                    aria-hidden="true"
                  ></span>
                </button>
                <div class="carousel-inner">
                  <div
                    class="carousel-item"
                    :class="{ active: index === slideBody }"
                    v-for="(bodyPart, index) in body.split('\n\n')"
                    :key="'item_' + index"
                    style="min-height: 120px"
                  >
                    <div>{{ bodyPart }}</div>
                  </div>
                </div>
                <button
                  class="carousel-control-next"
                  type="button"
                  data-bs-target="#carouselBody"
                  data-bs-slide="next"
                  style="position: static"
                >
                  <span
                    class="carousel-control-next-icon"
                    aria-hidden="true"
                  ></span>
                </button>
              </div>
              <div class="carousel-indicators" style="position: static">
                <button
                  v-for="(bodyPart, index) in body.split('\n\n')"
                  :key="'button_' + index"
                  type="button"
                  data-bs-target="#carouselBody"
                  :data-bs-slide-to="index"
                  :class="{ active: index === slideBody }"
                  style="background-color: #000"
                ></button>
              </div>
            </div>
          </div>
          <div class="popupButtons" v-if="buttonR">
            <div class="popupButton" @click="callBackButtonR" v-if="buttonR">
              {{ buttonR }}
            </div>
          </div>
          <div
            class="popupOptions"
            :class="optionType"
            v-if="options && options.length"
          >
            <template v-if="optionType === 'product'">
              <div class="option" v-for="option in options" :key="option.key">
                <div class="optionTitle">{{ $t(option.title) }}</div>
                <img
                  @load="onImgLoad"
                  class="optionImage"
                  :src="option.image"
                  ref="optionImages"
                />
                <div class="optionBody scroll" :style="{ height: heightBody }">
                  {{ $t(option.body) }}
                </div>
                <div
                  class="popupButton optionConfirm"
                  :class="{ disabled: option.disabled }"
                  @click="!option.disabled ? selectOption(option) : null"
                >
                  {{ $t(option.confirm) }}
                </div>
              </div>
            </template>
            <template v-else-if="optionType === 'test'"
              ><div
                class="option optionTest"
                :id="option.key"
                v-for="option in options"
                :key="option.key"
                :class="{ disabled: option.disabled }"
                @click="!option.disabled ? selectOption(option) : null"
              >
                <div class="optionTitle optionTitleTest">
                  <img
                    @load="onImgLoad"
                    class="optionPlayTest"
                    src="../../assets/images/play-octagon.png"
                  />
                  <span class="optionTitleTestText">
                    {{ $t(option.title) }}
                  </span>
                </div>
                <div
                  class="optionBody optionBodyTest"
                  :style="{ height: heightBody }"
                >
                  {{ $t(option.body) }}
                </div>
              </div></template
            >
            <template v-else-if="optionType === 'vertical'"
              ><div
                class="optionVertical"
                v-for="option in options"
                :key="option.key"
                @click="!option.disabled ? selectOption(option) : null"
              >
                <div
                  class="optionVerticalTitle"
                  :class="{ disabled: option.disabled }"
                >
                  <img
                    @load="onImgLoad"
                    class="optionVerticalTitleIcon"
                    src="../../assets/images/play-octagon.png"
                    :style="option.style"
                  />
                  <span class="optionVerticalTitleText" :style="option.style">
                    {{ $t(option.title) }}
                  </span>
                </div>
              </div></template
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    open: {
      default: false,
      required: true,
    },
    showInfoIcon: {
      default: false,
    },
    showClose: {
      default: true,
    },
    showMinimize: {
      default: false,
    },
    title: {
      required: false,
    },
    body: {
      required: false,
    },
    bodyType: {
      required: false,
      default: "text",
    },
    slideBody: {
      required: false,
      default: 0,
    },
    optionType: {
      required: false,
    },
    options: {
      required: false,
    },
    buttonR: {
      required: false,
    },
    height: {
      default: "350px",
      required: false,
    },
    width: {
      default: "638px",
      required: false,
    },
    maxWidth: {
      default: "800px",
      required: false,
    },
    minWidth: {
      default: null,
      required: false,
    },
    opacity: {
      default: 1,
      required: false,
    },
    heightBody: {
      default: "110px",
      required: false,
    },
    fontSizeBody: {
      default: "18px",
      required: false,
    },
    paddingText: {
      default: "0px 10px 10px 10px",
      required: false,
    },
    top: {
      required: false,
    },
    bottom: {
      required: false,
    },
    right: {
      required: false,
    },
    left: {
      required: false,
    },
    center: {
      default: true,
      required: false,
    },
    centerVertical: {
      default: false,
      required: false,
    },
    centerHorizontal: {
      default: false,
      required: false,
    },
    overlay: {
      default: false,
      required: false,
    },
    overlayColor: {
      default: "#00000069",
      required: false,
    },
    showBubble: {
      default: false,
      required: false,
    },
  },
  data() {
    return {
      vertivLogo: require("../../assets/svgs/vertivLogo.svg"),
      crossIcon: require("../../assets/svgs/crossIcon.svg"),
      minimizeIcon: require("../../assets/svgs/minimizeIcon.svg"), // minimizeIcon
      infoIcon: require("../../assets/svgs/infoIcon.svg"),
      imagesLoaded: 0,
      minimized: false,
    };
  },
  watch: {
    realOpen() {
      if (this.realOpen && this.bodyType === "carousel") {
        const myCarousel = document.getElementById("carouselBody");

        myCarousel.addEventListener("slide.bs.carousel", this.slideCarousel);

        this.$emit("update:slideBody", 0);
      } else if (this.bodyType === "carousel") {
        const myCarousel = document.getElementById("carouselBody");

        myCarousel.removeEventListener("slide.bs.carousel", this.slideCarousel);
      }
    },
  },
  computed: {
    realOpen() {
      let numberOfImages = 0;

      if (this.showInfoIcon) {
        numberOfImages++;
      }

      if (this.showClose) {
        numberOfImages++;
      }

      if (this.showMinimize) {
        numberOfImages++;
      }

      if (this.options && this.options.length) {
        const numberOfBigImages = this.options.filter((el) => el.image).length;

        numberOfImages += numberOfBigImages;

        if (["vertical", "test"].includes(this.optionType)) {
          numberOfImages += this.options.length;
        }
      }

      return this.imagesLoaded >= numberOfImages;
    },
  },
  methods: {
    slideCarousel(event) {
      this.$emit("update:slideBody", event.to);
    },
    onImgLoad() {
      this.imagesLoaded++;
    },
    closePopup() {
      this.imagesLoaded = 0;
      this.$emit("closeDialog");
      this.$emit("update:open", false);
    },
    togglePopup() {
      this.minimized = !this.minimized;
      this.minimizeIcon = this.minimized
        ? require("../../assets/svgs/maximizeIcon.svg")
        : require("../../assets/svgs/minimizeIcon.svg");
      this.$emit("togglePopup", this.minimized);
    },
    callBackButtonR() {
      this.imagesLoaded = 0;
      this.$emit("callBackButtonR", false);
    },
    selectOption(option) {
      this.imagesLoaded = 0;
      this.$emit("selectOption", { option });
    },
  },
};
</script>
<style lang="scss" scoped>
$utilityGrey: #333333;
$white: #fff;
$orange: #fe5b1b;

.overlay {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 6;
  width: 100vw;
  height: 100vh;
}

.popup {
  position: absolute;
  z-index: 7;
  background-color: $utilityGrey;
  border-radius: 5px;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.1);
  pointer-events: auto;

  &.center {
    transform: translate(-50%, -50%);
  }

  &.centerVertical {
    transform: translateY(-50%);
  }

  &.centerHorizontal {
    transform: translateX(-50%);
  }

  &.showBubble {
    &:after {
      // content: "";
      // position: absolute;
      // right: 0;
      // top: 27px;
      // width: 0;
      // height: 0;
      // border: 27px solid transparent;
      // border-left-color: $white;
      // border-right: 0;
      // margin-top: -27px;
      // margin-right: -27px;

      content: "";
      position: absolute;
      display: block;
      width: 0;
      z-index: 1;
      border-style: solid;
      border-width: 20px 0 0 20px;
      border-color: transparent transparent transparent $white;
      top: 50%;
      right: -20px;
      margin-top: -10px;
    }
  }
}

.popupHeader {
  width: 100%;
  margin: 0;
  height: 115px;
}

.popupHeaderLogo {
  height: 100%;
  width: 100%;
  text-align: center;
  padding: 25px 0;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  .popupInfoIcon {
    width: 32px;
    height: 32px;
  }
}

.popupHeaderTitle {
  line-height: 36px;
  // height: 36px;
  width: 100%;
  text-align: center;
  font-family: Unna;
  font-size: 36px;
  color: $white;
}

.scroll {
  overflow-y: auto;
}

/* Handle */
.scroll::-webkit-scrollbar {
  border: none;
  border-radius: 0px !important;
  background: #e5e5e5;
  height: 232px !important;
  width: 8px;
}

.scroll::-webkit-scrollbar-thumb {
  border-radius: 0px !important;
  background: #cccccc;
  height: 10%;
  width: 8px;
}

.scroll::-webkit-scrollbar- {
  border-radius: 0px !important;
  background: #cccccc;
  height: 10%;
  width: 8px;
}

.popupClose {
  position: absolute;
  top: 10px;
  right: 10px;
  cursor: pointer;
  width: 15px;
}

.popupMinimize {
  position: absolute;
  top: 10px;
  right: 40px;
  cursor: pointer;
  width: 15px;
}

.middleLine {
  width: 100%;
  position: absolute;
  right: 0px;
  top: 115px;
  margin: 0;
  height: 5px;
  background-color: $orange;
}

.popupTextSection {
  width: 100%;
  border-radius: 5px 5px 5px 5px; // 5px 0 5px 5px;
  margin: 0;
  background-color: $white;
  padding-top: 20px;

  .textSection {
    margin: auto;
    height: 100%;
    justify-content: center;

    .popupText {
      width: 100%;
      text-align: justify;
      padding-top: 6px;
      font-family: Calibre;
      font-weight: 400;
      line-height: 20px;
      color: $utilityGrey;

      white-space: break-spaces;
    }

    .popupButtons {
      margin-top: 10px;
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: center;
    }

    .popupButton {
      width: 202px;
      height: 43px;
      padding: 12px 28px 11px 26px !important;
      border-radius: 2px;
      background-color: #fe5b1b;
      font-family: Calibre;
      font-size: 18px;
      text-align: center;
      color: #fff !important;
      cursor: pointer;

      &.disabled {
        background-color: #cccccc;
        color: #666666;
        cursor: not-allowed;
      }
    }

    .popupButton:hover:not(.disabled) {
      background-color: #fe791b;
      transition: 0.2s;
    }

    .popupOptions {
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      justify-content: center;

      margin-bottom: 7px;

      &.vertical {
        margin-top: 20px;
        padding-left: 25px;
      }

      .option {
        width: calc(50% - 40px);
        margin: 0 20px 23px 20px;

        background: #f0f0f0;
        border: 1px solid #333333;
        border-radius: 6px;

        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;

        &.optionTest {
          align-items: flex-start;
          white-space: pre-line;
          cursor: pointer;

          &.disabled {
            background-color: #cccccc;
            color: #666666;
            cursor: not-allowed;
          }
        }

        .optionTitle {
          width: 70%;
          min-height: 48px;
          margin: 25px auto 15px auto;

          font-family: "Calibre";
          font-style: normal;
          font-weight: 400;
          font-size: 20px;
          line-height: 24px;
          text-align: center;

          color: #000000;

          &.optionTitleTest {
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: flex-start;
            height: 22px;
            min-height: 22px;

            font-weight: 500;
            font-size: 20px;
            /* or 138% */

            letter-spacing: 1px;
            text-transform: uppercase;

            color: #000000;

            margin: 19px 0 0 22px;

            .optionPlayTest {
              min-height: 22px;
              height: 22px;
              margin-right: 20px;
            }

            .optionTitleTestText {
              line-height: 22px;
              height: 16px;
              min-height: 16px;
            }
          }
        }

        .optionImage {
          background: #fffcfc;
          border: 1px solid #333333;
          border-radius: 6px;
          object-fit: contain;
          width: calc(100% - 80px);
          margin: 0 auto;
          padding: 15px;
        }

        .optionBody {
          font-family: "Calibre";
          font-style: normal;
          font-weight: 400;
          font-size: 18px;
          line-height: 20px;
          text-align: left;
          color: #000000;

          margin: 15px;

          &.optionBodyTest {
            height: 40px !important;
            margin: 7px 10px 12px 65px;
          }
        }

        .optionConfirm {
          margin-bottom: 15px;
        }
      }

      .optionVertical {
        width: 100%;
        margin: 0 20px 20px 0;

        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: flex-start;

        .optionVerticalTitle {
          font-family: "Calibre";
          font-style: normal;
          line-height: 24px;
          text-align: center;
          display: flex;
          flex-direction: row;
          align-items: center;
          justify-content: flex-start;
          height: 22px;
          font-weight: 500;
          font-size: 20px;
          letter-spacing: 1px;
          text-transform: uppercase;
          color: #000000;
          cursor: pointer;
          gap: 20px;

          &.disabled {
            cursor: not-allowed;
          }

          .optionVerticalTitleIcon {
            height: 22px;
          }

          .optionVerticalTitleText {
            height: 20px;
            font-family: "Calibre";
            font-style: normal;
            font-weight: 500;
            font-size: 20px;
            text-align: center;
            letter-spacing: 1px;
            text-transform: uppercase;
            color: #000000;
            padding: 1px 0;
          }
        }
      }
    }
  }
}
</style>
